import httpClient from "../../../shared/api/httpClient";

export const kpisApi = {
  get: () => httpClient.get("/api/v1/dashboard/kpis").then((r) => r.data.dados),
};
